export const GET_PROJECTS = 'fulcrum/containers/MyProjects/GET_PROJECTS'
export const HEALTH_COLORS = {
    red: '#ff2a00',
    yellow: '#ffd800',
    green: '#82c908'
  }

export const rowSize = [
  100,
  500
]

export const FROM_SIZE = 100

export const VIEW_ALL = 'View all'


export const LIFECYCLE_STATES = [
  {value: 'Kickoff', label: 'Kickoff'},
  {value: 'Design Review', label: 'Design Review'},
  {value: 'Qualification', label: 'Qualification'},
  {value: 'Mass Production', label: 'Mass Production'},
  {value: 'End of Life', label: 'End of Life'},
  {value: 'Cancelled', label: 'Cancelled'},
  {value: 'On Hold', label: 'On Hold'},
]

export const UPDATE_MY_PROJECTS_LIST = 'fulcrum/containers/MyProjects/UPDATE_MY_PROJECTS_LIST'
export const UPDATE_SELECTED_PROJECTS = 'fulcrum/containers/MyProjects/UPDATE_SELECTED_PROJECTS'
export const CLEAR_SELECTED_PROJECTS = 'fulcrum/containers/MyProjects/CLEAR_SELECTED_PROJECTS'
export const APPLY_CHANGES = 'fulcrum/containers/MyProjects/APPLY_CHANGES'
export const UPDATE_CHANGED_PROJECTS = 'fulcrum/containers/MyProjects/UPDATE_CHANGED_PROJECTS'

export const SUBMIT_CHANGES = 'fulcrum/containers/MyProjects/SUBMIT_CHANGES'
export const CANCEL_CHANGES = 'fulcrum/containers/MyProjects/CANCEL_CHANGES'

export const ON_SECTION_RENDER = 'fulcrum/containers/MyProjects/ON_SECTION_RENDER'
export const ON_HEADER_CLICK = 'fulcrum/containers/MyProjects/ON_HEADER_CLICK'
export const UPDATE_CURRENT_INDEX = 'fulcrum/containers/MyProjects/UPDATE_CURRENT_INDEX'

export const UPDATE_INPUT_HEADER_LIST = 'fulcrum/containers/MyProjects/UPDATE_INPUT_HEADER_LIST'
export const UPDATE_MENU_ACTIVE = 'fulcrum/containers/MyProjects/UPDATE_MENU_ACTIVE'
export const ON_MENU_HIDE = 'fulcrum/containers/MyProjects/ON_MENU_HIDE'
export const ON_APPLY_FILTER = 'fulcrum/containers/MyProjects/ON_APPLY_FILTER'
export const ON_INPUT_HEADER_VALUE_CHANGE = 'fulcrum/containers/MyProjects/ON_INPUT_HEADER_VALUE_CHANGE'
export const DELETE_FILTER = 'fulcrum/containers/MyProjects/DELETE_FILTER'

export const ON_COLUMN_REORDER = 'fulcrum/containers/MyProjects/ON_COLUMN_REORDER'

export const UPDATE_LIST_ORDER = 'fulcrum/containers/MyProjects/UPDATE_LIST_ORDER'
export const UPDATE_SORT_INDEX = 'fulcrum/containers/MyProjects/UPDATE_SORT_INDEX'
export const CLEAR_HEADER_FILTERS = 'fulcrum/containers/MyProjects/CLEAR_HEADER_FILTERS'
export const UPDATE_CUSTOM_COL_ORDER = 'fulcrum/containers/MyProjects/UPDATE_CUSTOM_COL_ORDER'
export const CLEAR_CUSTOM_COL_ORDER = 'fulcrum/containers/MyProjects/CLEAR_CUSTOM_COL_ORDER'

export const UPDATE_FROM = 'fulcrum/containers/MyProjects/UPDATE_FROM'

export const ON_HEADER_FILTER_CHANGE = 'fulcrum/containers/MyProjects/ON_HEADER_FILTER_CHANGE'
export const UPDATE_HEADER_FILTER = 'fulcrum/containers/MyProjects/UPDATE_HEADER_FILTER'
export const REMOVE_HEADER_FILTER = 'fulcrum/containers/MyProjects/REMOVE_HEADER_FILTER'

export const UPDATE_SORT_BY = 'fulcrum/containers/MyProjects/UPDATE_SORT_BY'
export const ON_SORT_CHANGE = 'fulcrum/containers/MyProjects/ON_SORT_CHANGE'

export const ON_INPUT_CHANGE = 'fulcrum/containers/MyProjects/ON_INPUT_CHANGE'
export const UPDATE_INPUT_VALUE = 'fulcrum/containers/MyProjects/UPDATE_INPUT_VALUE'

export const ON_SUBMIT = 'fulcrum/containers/MyProjects/ON_SUBMIT'

export const ON_ROW_SIZE_CHANGE = 'fulcrum/containers/MyProjects/ON_ROW_SIZE_CHANGE'
export const UPDATE_ROW_SIZE = 'fulcrum/containers/MyProjects/UPDATE_ROW_SIZE'
export const UPDATE_MAX_ROW_SIZE = 'fulcrum/containers/MyProjects/UPDATE_MAX_ROW_SIZE'

export const TOGGLE_POPUP = 'fulcrum/containers/MyProjects/TOGGLE_POPUP'
export const FINISH_LOADING = 'fulcrum/containers/MyProjects/FINISH_LOADING'
export const UPDATE_POPUP_PAGE = 'fulcrum/containers/MyProjects/UPDATE_POPUP_PAGE'

export const POST_PROJECT_CHANGES_ERROR = 'fulcrum/containers/MyProjects/POST_PROJECT_CHANGES_ERROR'
export const POST_PROJECT_CHANGES_START = 'fulcrum/containers/MyProjects/POST_PROJECT_CHANGES_START'
export const POST_PROJECT_CHANGES_SUCCESS = 'fulcrum/containers/MyProjects/POST_PROJECT_CHANGES_SUCCESS'
export const SHOW_CHANGED_PROJECTS = 'fulcrum/containers/MyProjects/SHOW_CHANGED_PROJECTS'

export const CLEAR_CHANGES = 'fulcrum/containers/MyProjects/CLEAR_CHANGES'
export const UPDATE_ERRORS = 'fulcrum/containers/MyProjects/UPDATE_ERRORS'

export const SELECT_CUSTOM_VIEW = 'fulcrum/containers/MyProjects/SELECT_CUSTOM_VIEW'
export const UPDATE_ALL_HEADER_FILTERS = 'fulcrum/containers/MyProjects/UPDATE_ALL_HEADER_FILTERS'
export const RESET_HEADER_FILTERS = 'fulcrum/containers/MyProjects/RESET_HEADER_FILTERS'

export const TOGGLE_NOTIFY = 'fulcrum/containers/MyProjects/TOGGLE_NOTIFY'

export const FILTER_CHANGE = 'fulcrum/containers/MyProjects/FILTER_CHANGE'

export const defaultSearchFilterSource = [
  'product_sku',
  'lifecycle',
  'project_health',
  'ae_resource_level',
  'ae_notes',
  'project_hierarchy',
  'partner_site',
  'project_waiver_status',
  'project_waiver_details',
  'project_restricted',
  'schedule.evt_start',
  'schedule.dvt_start',
  'schedule.pvt_start',
  'schedule.pilot_start',
  'schedule.mp_start',
  'schedule.sbios_lock',
  'schedule.whql_rc',
  'schedule.whql_production',
  'schedule.sop_start',
  'schedule.a_sample',
  'schedule.b_sample',
  'schedule.c_sample',
  'schedule.d_sample',
  'last_weekly_update.date',
  'last_weekly_update.role',
  'last_weekly_update.message',
  'last_weekly_update.username'
]

export const defaultSearchFilters =  [
  'id',
  'project_name',
  'product_sku',
  'lifecycle',
  'project_health',
  'ae_resource_level',
  'ae_notes',
  'project_hierarchy',
  'partner_site',
  'project_waiver_status',
  'project_waiver_details',
  'project_restricted',
  'schedule.evt_start',
  'schedule.dvt_start',
  'schedule.pvt_start',
  'schedule.pilot_start',
  'schedule.mp_start',
  'schedule.sbios_lock',
  // 'schedule.whql_rc',
  // 'schedule.whql_production',
  // 'schedule.sop_start',
  // 'schedule.a_sample',
  // 'schedule.b_sample',
  // 'schedule.c_sample',
  // 'schedule.d_sample',
  'last_weekly_update.date',
  'last_weekly_update.role',
  'last_weekly_update.message',
  'last_weekly_update.username'
]

export const listOrder = Object.freeze(
  defaultSearchFilters.reduce((result, category, index) => ({
    ...result,
    [category]: index
  }), {})
)

export const defaultSearchFilterNames = {
  'id': 'ID',
  'project_name': 'Project Name',
  'lifecycle': 'Lifecycle',
  'project_health': 'Project Health',
  'ae_resource_level': 'AE Resource Level',
  'ae_notes': 'AE Notes',
  'project_hierarchy': ' Project Hierarchy',
  'partner_site': 'Partner Site',
  'project_waiver_status': 'Project Waiver Status',
  'project_waiver_details': 'Project Waiver Details',
  'project_restricted': 'Project Restricted',
  'schedule': 'Schedule',
  'schedule.evt_start': 'Schedule - EVT Start',
  'schedule.dvt_start': 'Schedule - DVT Start',
  'schedule.pvt_start': 'Schedule - PVT Start',
  'schedule.pilot_start': 'Schedule - Pilot Start',
  'schedule.mp_start': 'Schedule - MP Start',
  'schedule.sbios_lock': 'Schedule - SBIOS Lock',
  'schedule.whql_rc': 'Schedule - WHQL RC',
  'schedule.whql_production': 'Schedule - WHQL Production',
  'schedule.sop_start': 'Schedule - SOP Start',
  'schedule.a_sample': 'Schedule - A Sample',
  'schedule.b_sample': 'Schedule - B Sample',
  'schedule.c_sample': 'Schedule - C Sample',
  'schedule.d_sample': 'Schedule - D Sample',
  'last_weekly_update': 'Last Weekly Update',
  'last_weekly_update.date': 'Weekly Update - Date',
  'last_weekly_update.role': 'Weekly Update - Role',
  'last_weekly_update.message': 'Weekly Update - Message',
  'last_weekly_update.username': 'weekly Update - Username',
  'category': {
    'cpu': 'CPU',
    'clock': 'Clock',
    'display_connector': 'Display',
    'general': 'General',
    'input_connector': 'Input Connector',
    'mechanical': 'Mechanical',
    'memory': 'Memory',
    'panel': 'Panel',
    'partners': 'Partners',
    'pcb': 'PCB',
    'power': 'Power',
    'power_supply': 'Power Supply',
    'product': 'Product',
    'system': 'System',
    'thermal': 'Thermal',
    'voltage_regulator': 'Voltage Regulator',
    'workflow': 'Workflow',
    'schedule': 'Schedule',
    'product_storage': 'Storage',
    'nic': 'Network Interface Controller',
    'pcie_switch_retimer': 'PCIe Switch/Retimer',
    'baseboard': 'Baseboard',
    'io_switch_board': 'I/O Switch Board',
    'nvlink_bridge':'NVLink Bridge',
    'system_power_supply': 'System Power Supply',
    'system_management': 'System Management',
    'baseboard_power': 'Baseboard Power',
    'nvqual': 'NVQual',
    'cpm': 'Customer Program Management',
    'support_team': 'Support Team',
    'project_features': 'Project Features',
    'system_software': 'System Software'
  },
    'display_connector': {
      'connector_bracket': 'Display Connector Bracket',
      'connector_feature': 'Display Connector Feature',
      'connector_source': 'Display Connector Source',
      'connector_type': 'Display Connector Type',
      'link_type': 'Display Connector Link'
    },
    'cpu': {
      'architecture': 'CPU Architecture',
      'brand': 'CPU Brand',
      'classification': 'CPU Classification',
      'core_count': 'CPU Core Count',
      'frequency': 'CPU Core Frequency'

    },
    'baseboard_power_components': {
      'component': 'Baseboard Component',
      'power': 'Baseboard Component Power'
    },
    'clock': {
      'base_clock': 'Base Clock',
      'oc_bin': 'OC BIN',
      'boost_clock': 'Boost Clock',
      'vf_offset': 'VF Offset',
      'tgp': 'min TGP'
    },
    'input_connector': 'Input Connector',
    'memory': {
      'clock': 'Memory Clock',
      'density': 'Memory Size',
      'organization_size': 'Memory Org. Size',
      'organization_width': 'Memory Org. Width',
      'part_number': 'Memory Part Number',
      'part_type': 'Memory Part Type',
      'speed_grade': 'Memory Speed Grade',
      'vendor_name': 'Memory Vendor Name',
      'config': 'Memory Configuration'
    },
    'pcb_stackup': 'PCB Layer Count',
    'panel': {
      'height': 'Panel Height',
      'part_number': 'Panel Part Number',
      'refresh_rate': 'Panel Refresh Rate',
      'size': 'Panel Size',
      'vendor_name': 'Panel Vendor Name',
      'width': 'Panel Width'
    },
    'features': 'Project Features',
    'project_ssid': {
      'value': 'Project SSID'
    },
    'project_svid': {
      'value': 'Project SVID'
    },
    'voltage_regulator': {
      'part_number': 'Voltage Regulator Part Number',
      'part_type': 'Voltage Regulator Part Type',
      'phase_count': 'Voltage Regulator Phase Count',
      'efficiency': 'Voltage Regulator Efficiency',
      'rail_type': 'Voltage Regulator Rail Type',
      'vendor_name': 'Voltage Regulator Vendor Name'
    },
    'power_components': {
      'rail_type': 'Power Component Rail Type',
      'component_type': 'Power Component Type',
      'component_part': 'Power Component Part',
      'component_details': 'Power Component Details'
    },
    'power_monitor_ic': {
      'details': 'Power Monitor IC Details',
      'type': 'Power Monitor IC Type',
      'part_number': 'Power Monitor IC Part Number',
      'vendor': 'Power Monitor IC Vendor'
    },
    'product_storage': {
      'count': 'Storage Count',
      'details': 'Storage Details',
      'storage_type': 'Storage Type'
    },
    'nic': {
      'nic_vendor': 'NIC Vendor',
      'nic_speed': 'NIC Speed (Gbps)',
      'nic_count': 'NIC Count',
      'nic_protocol_type': 'NIC Protocol Type'
    },
    'mission_profile': {
      'vehicle_type': 'Vehicle Type',
      'service_life': 'Service Life (years)',
      'power_on_hours': 'Power On Hours',
      'power_off_hours': 'Power Off Hours',
      'mileage': 'Mileage',
      'power_on_off_cycles': 'Power On/Off Cycle (daily)',
      'power_on': 'Power On(s)',
      'power_off': 'Power Off(s)'
    },
    'pcie_switch_retimer': {
      'vendor': 'PCIe Switch/Retimer Vendor',
      'part_number': 'PCIe Switch/Retimer Part Number',
      'count': 'PCIe Switch/Retimer Count',
      'details': 'PCIe Switch/Retimer Details'
    },
    'cpm': {
      'nine_hundred_level_part_number': '900-Level Part Number',
      'cpm_project_priority_source': 'Project Priority',
      'cpm_product_sampled_source': 'Product Sampled',
      'cpm_ready_for_review_source': 'Ready For GAM Review',
      'cpm_publish_to_web_source': 'Publish to Web',
      'cpm_notes': 'CPM Notes',
      'general_availability': 'General Availability',
      'prod_release': 'Product Release Date'
    },
    'support_team': {
      'customer_program_manager': 'Customer Program Manager',
      'applications_engineering_manager': 'Applications Engineering Manager',
      'account_applications_engineer': 'Account Applications Engineer',
      'field_applications_engineer': 'Field Applications Engineer',
      'applications_engineering_director': 'Applications Engineering Director',
      'product_applications_engineer': 'Product Applications Engineer',
      'product_manager': 'Product Manager',
      'customer_program_director': 'Customer Program Director',
      'observer': 'Observer'
    },
    'project_features': {
      'ms_hybrid_support': 'MS Hybrid Support',
      'discrete_mode': 'Discrete Mode',
      'aspm_support': 'ASPM Support',
      'gc6_support': 'GC6 Support',
      'gsync_dd_support': 'GSync DD Support',
      'gsync_nvsr_support': 'GSync NVSR Suppor',
      'gsync_hdr_support': 'GSync HDR Support',
      'vapor_chamber': 'Vapor Chamber',
      'heat_pipes': 'Heat Pipes',
      '2_way_sli': '2-way SLI',
      '3_way_sli': '3-way SLI',
      'thermal_led': 'Thermal LED',
      'rtd3': 'RTD3',
      'zero_power': 'Zero Power',
      'power_brake_b30': 'Power Brake (B30)',
      'smbpbi': 'SMBPBI',
      'smbpbi_over_pcie': 'SMBPBI over PCIe',
      'programmable_edp_peak': 'Programmable EDP Peak',
      'sr_iov': 'SR-IOV',
      'rtx_studio': 'RTX Studio',
      'dynamic_display_switching': 'Dynamic Display Switching (DDS)',
      'pcie_cable': 'PCIe Cable',
      'system_wake_on_wifi_support': 'System Wake on Wifi Support',
      'whispermode': 'WhisperMode',
      'fanstop': 'FanStop',
      'arm_uefi': 'ARM UEFI',
      'nvlink_bridge_support': 'NVlink Bridge Support',
      'nvidia_certified': 'NVIDIA Certified',
      'virtual_gpu_certified': 'Virtual GPU Certified',
      'voltage_monitoring': 'Voltage Monitoring',
      'in_system_test': 'In System Test (IST)',
      'multi_instance_gpu': 'Multi-Instance GPU (MIG)',
      'video_decode': 'Video Decode',
      'optical_flow_accelerator': 'Optical Flow Accelerator (OFA)',
      'nvaie_compatible':'NVIDIA AI Enterprise (NVAIE) Compatible', 
      'workstation':'Workstation',
      'mobile_workstation':'Mobile Workstation',
      'datacenter':'Datacenter',
      'enterprise_edge':'Enterprise Edge',
      'industrial_edge':'Industrial Edge',
      'high_density_virtualization':'High Density Virtualization',
      'ngc_ready':'NGC Ready'
    },
    'io_switch_board_config': 'I/O Switch Board Configuration',
    'created_at': 'Created On',
    'created_by': 'Created By',
    'project_description': 'Project Description',
    'associated_projects': 'Associated Projects',
    'ae_regions': 'AE Region',
    'nvqual_status': 'NVQual Result',
    'nvqual_nvbugs': 'NVQual NVBugs',
    'form_factor': 'Form Factor',
    'project_type': 'Project Type',
    'mechanical_bottom_z_height': 'Bottom Z-height',
    'mechanical_top_z_height': 'Top Z-height',
    'pcb_height': 'PCB Height',
    'pcb_length': 'PCB Length',
    'pcb_material': 'PCB Material',
    'pcb_technology': 'PCB Technology',
    'pcb_thickness': 'PCB Thickness',
    'partner': 'Partner',
    'odm': 'Partner ODM',
    'baseboard_power_total': 'Total Baseboard Power Rated (W)',
    'battery_size': 'Battery Size',
    'battery_tgp': 'Total Graphics Power (TGP) on Battery (DC Mode)',
    'battery_discharge_rate': 'Battery Discharge Rate',
    'battery_ac_adapter_wattage': 'AC Adapter Wattage',
    'battery_ac_adapter_voltage': 'AC Adapter Voltage',
    'battery_ac_adapter_size': 'AC Adapter Size (Height, Width, Length)',
    'advanced_optimus': 'Advanced Optimus',
    'display_ms_hybrid_mode': 'MS Hybrid Mode',
    'display_discrete_mode_no_edp_mux': 'Discrete Mode with eDP Mux',
    'display_edp_mux_part_number': 'eDP Mux Part Number',
    'power_tgp_max': 'TGP Max (W)',
    'power_tgp_rated': 'TGP Rated (W)',
    'gpu_count_per_baseboard': 'GPU Count per Baseboard',
    'gpu_frequency': 'GPU Frequency (MHz)',
    'gpu_tray_height': 'GPU Tray Height',
    'system_cpu_pcie_link': 'PCIe Links per CPU Socket',
    'system_memory_size': 'System Memory Size (GB)',
    'system_pcie_max_depth': 'Maximum PCIe Depth (CPU to GPU)',
    'customer_class': 'Customer Class',
    'product_brand': 'Product Brand',
    'product_class': 'Product Class',
    'product_family': 'Product Family',
    'product_line': 'Product Line',
    'product_platform': 'Product Platform',
    'product_segment': 'Product Segment',
    'product_sku': 'Product SKU',
    'chassis_height': 'Chassis Height',
    'chassis_length': 'Chassis Length',
    'chassis_width': 'Chassis Width',
    'pcie_speed': 'PCIe Speed',
    'pcie_width': 'PCIe Width',
    'system_cpu_tdp': 'System CPU TDP',
    'system_management_interface': 'System Management Interface',
    'system_memory': 'System Memory',
    'system_nvlink_speed': 'System NVLink Speed (Gbps)',
    'system_nvlink_topology': 'System NVLink Topology',
    'system_rack_units': 'System Rack Units',
    'system_power_source': 'System Power Source',
    'system_pcie_speed': 'PCIe Gen Speed',
    'system_pcie_width': 'System PCIe Width',
    'target_application': 'Target Applications',
    'system_model_name': 'System Model Name',
    'system_form_factor': 'System Form Factor',
    'system_rack_unit':'System Rack Units',
    'system_jbog': 'Discrete GPU Node (JBOG)',
    'system_cpu_count':'CPU Socket Count',
    'system_gpu_count':'GPU Count',
    'system_notes': 'System Notes',
    'os_version': 'OS Version',
    'external_source': 'External Source',
    'gpu_driver_version': 'GPU Driver Version',
    'cpu_core_count':'CPU Core Count',
    'cpu_frequency':'CPU Frequency (GHz)',
    'thermal_acoustic_temperature_limit': 'Acoustic Temperature Limit',
    'thermal_capacity': 'Total Thermal Capacity',
    'thermal_cooler_design_source': 'Cooler Design',
    'thermal_cooler_topology': 'Cooler Topology',
    'thermal_cooler_type': 'Thermal Cooler/Solution Type',
    'thermal_cpu_capacity': 'CPU Capacity',
    'thermal_gpu_capacity': 'GPU Capacity',
    'thermal_fan_connector': 'Fan Connector',
    'thermal_fan_cooler_contact': 'Fan Contact',
    'thermal_fan_count': 'Fan Count',
    'thermal_fan_type': 'Fan Type',
    'thermal_airflow_cfm': 'Thermal Airflow CFM',
    'thermal_airflow_direction': 'Thermal Airflow Direction',
    'thermal_airflow_inlet_temperature': 'Thermal Airflow Inlet Temperature',
    'thermal_airflow_inlet_max_temperature': 'Thermal Airflow Inlet Max Temperature',
    'thermal_cooler_vendor': 'Thermal Solution Vendor',
    'thermal_interface_material': 'Thermal Interface Material (TIM)',
    'tim_2_bond_line_thickness':'TIM2 Bond Line Thickness',
    'tim_3_bond_line_thickness':'TIM3 Bond Line Thickness',
    'thermal_average_pressure': 'Thermal Average Pressure (PSI)',
    'thermal_heatpipe': 'Thermal Heatpipe',
    'thermal_liquid_flow_direction': 'Thermal Liquid Flow Direction',
    'thermal_liquid_flow_rate': 'Thermal Liquid Flow Rate (L/min)',
    'thermal_reference_type': 'Thermal Reference Type',
    'thermal_stackup': 'Thermal Stackup',
    'gpu_target_temperature_thermal_simulation': 'GPU Target Temperature (Thermal Simulation)',
    'baseboard_count': 'Baseboard Count',
    'baseboard_input_voltage':'Baseboard Input Voltage',
    'nvlink_bridge_mechanism': 'NVLink Bridge Mechanism',
    'nvlink_board_material': 'NVLink Bridge Board Material',
    'nvlink_board_manufacturer': 'NVLink Bridge Board Manufacturer',
    'system_power_supply_config': 'Power Supply Configuration',
    'max_pq': 'Max-Q',
    'max_pq_certification_participation': 'Max-Q Certification Participation',
    'max_pq_configurable_tgp_mode': 'Max-Q Configurable TGP Mode',
    'max_pq_configurable_tgp_value': 'Max-Q Configurable TGP Value',
    'max_pq_platform_power_aware_gpu_boost': 'Dynamic Boost',
    'module_voltage_min': 'Module Voltage (Min.)',
    'module_voltage_max': 'Module Voltage (Max.)'
  }


export const defaultSupportTeamFilters = [
  'product_applications_engineer',
  'applications_engineering_director',
  'product_manager',
  'applications_engineering_manager',
  'customer_program_director',
  'customer_program_manager',
  'account_applications_engineer'
]

export const TRUNCATE = [{label: 'project_description', value: 40}]

export const SCHEDULE = [
  'evt_start',
  'dvt_start',
  'pvt_start',
  'pilot_start',
  'mp_start',
  'sbios_lock',
  'whql_rc',
  'whql_production',
  'a_sample',
  'b_sample',
  'c_sample',
  'd_sample',
  'sop_start'
]

export const SCHEDULE_REFORMAT = [
  'WHQL RC',
  'MP Start',
  'DVT Start',
  'EVT Start',
  'PVT Start',
  'SOP Start',
  'SBIOS/VBIOS Lock',
  'Pilot Start',
  'WHQL Production',
  'A Sample',
  'B Sample',
  'C Sample',
  'D Sample'
]
export const WEEKLY_UPDATE_FIELDS = [
  {
    'category': 'last_weekly_update',
    'type': 'last_weekly_update.date'
  },
  {
    'category': 'last_weekly_update',
    'type': 'last_weekly_update.role'
  },
  {
    'category': 'last_weekly_update',
    'type': 'last_weekly_update.message'
  },
  {
    'category': 'last_weekly_update',
    'type': 'last_weekly_update.username'
  }
]

export const SCHEDULE_DROPDOWN = [
  {value: 'evt_start', label: 'EVT Start'},
  {value: 'dvt_start', label: 'DVT Start'},
  {value: 'pvt_start', label: 'PVT Start'},
  // {value: 'sop_start', label: 'SOP Start'},
  {value: 'pilot_start', label: 'Pilot Start'},
  {value: 'mp_start', label: 'MP Start'},
  {value: 'sbios_lock', label: 'SBIOS Lock'},
  {value: 'whql_rc', label: 'WHQL RC'},
  {value: 'whql_production', label: 'WHQL Production'},
  {value: 'a_sample', label: 'A Sample'},
  {value: 'b_sample', label: 'B Sample'},
  {value: 'c_sample', label: 'C Sample'},
  {value: 'd_sample', label: 'D Sample'},
]